/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: "false" | "null" | "true" }} Activate_In_Certain_RoomsInputs */



/**
* | value | output |
* | --- | --- |
* | "false" | "Disabled in all selected rooms" |
* | "null" | "Enabled in some selected rooms" |
* | "true" | "Enabled in all selected rooms" |
*
* @param {Activate_In_Certain_RoomsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const activate_in_certain_rooms = /** @type {((inputs: Activate_In_Certain_RoomsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activate_In_Certain_RoomsInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.value === "false") return /** @type {LocalizedString} */ (`Disabled in all selected rooms`);
		if (i?.value === "null") return /** @type {LocalizedString} */ (`Enabled in some selected rooms`);
		if (i?.value === "true") return /** @type {LocalizedString} */ (`Enabled in all selected rooms`);
		return /** @type {LocalizedString} */ ("activate_in_certain_rooms");
	}
	{
		if (i?.value === "false") return /** @type {LocalizedString} */ (`Désactivé dans toutes les pièces sélectionnées`);
		if (i?.value === "null") return /** @type {LocalizedString} */ (`Activé dans certaines pièces sélectionnées`);
		if (i?.value === "true") return /** @type {LocalizedString} */ (`Activé dans toutes les pièces sélectionnées`);
		return /** @type {LocalizedString} */ ("activate_in_certain_rooms");
	}
});